import {
    addressWithoutPOBox,
    isState,
    phoneValidation,
    postalCodeUS,
} from '@/components/Helpers/validationHelpers.ts';
import type {TFunction} from 'i18next';
import moment, {type Moment} from 'moment';
import {z} from 'zod';

export const form200Schema = (t: TFunction<'translation', undefined>) =>
    z.object({
        legalFirstName: z
            .string({message: `${t('sefLegalFirstName')} ${t('requiredError')}`})
            .min(1),
        legalLastName: z.string({message: `${t('sefLegalLastName')} ${t('requiredError')}`}).min(1),
        legalMiddleName: z.string().nullish(),
        preferredName: z.string().nullish(),
        dob: z.custom<Moment>(val => moment.isMoment(val) && val.isValid(), {
            message: 'Invalid date',
        }),
        country: z.string({message: `${t('sef200Country')} ${t('requiredError')}`}),
        entryDate: z.custom<Moment>(() => true, {message: 'Invalid date'}).nullish(),
        ethnicity: z.string({message: `${t('ethnicity')} ${t('requiredError')}`}),
        race: z.array(z.string()).nullish(),
        gender: z.string({message: `${t('sef200Gender')} ${t('requiredError')}`}),
        registerForGrade: z.coerce
            .string({message: `${t('sef200Grade')} ${t('requiredError')}`})
            .transform(str => Number(str)),
        address: addressWithoutPOBox(`${t('sef200Address')} ${t('requiredError')}`),
        city: z.string({message: `${t('sef200City')} ${t('requiredError')}`}),
        state: isState,
        zip: postalCodeUS(`${t('sef200Zip')} ${t('requiredError')}`),
        mobilePhone: phoneValidation(t('phoneValidation'), true),
        email: z.preprocess(
            v => (v === '' || v == null ? null : v),
            z.union([z.string().email(), z.null()]),
        ),
    });

//refine<RefinedOutput extends Output>(check: (arg: Output) => arg is RefinedOutput, message?: string | CustomErrorParams | ((arg: Output) => CustomErrorParams)): ZodEffects<this, RefinedOutput, Input>;
export const form200Refine = (
    schema: ReturnType<typeof form200Schema>,
    t: TFunction<'translation', undefined>,
) => {
    return schema
        .refine(
            formData => {
                return formData.country !== '1000'
                    ? (formData.entryDate?.isValid() ?? false)
                    : true;
            },
            {
                message: t('requiredDateOther'),
                path: ['entryDate'],
            },
        )
        .refine(formData => formData.race?.length, {
            message: `${t('race')} ${t('requiredError')}`,
            path: ['race'],
        })
        .refine(
            ({email, mobilePhone}) => {
                return email || mobilePhone;
            },
            {
                message: `${t('sef200MobilePhone')} or ${t('sef200Email')} is required`,
                path: ['mobilePhone'],
            },
        );
};
